/**
 * Converts a string or number array to a Postgres array literal.
 */
export const convertArrayToPgLiteral = (arr: string[] | number[]) => {
  return `{${arr.join(',')}}`;
};
